import {RegionModel} from "./RegionModel";
import {LocalCustomerModel} from "./LocalCustomerModel";
import {ResourcesUnitModel} from "./ResourcesUnitModel";
import {ProviderModel} from "./ProviderModel";
import {ContractTypeModel} from "./ContractTypeModel";

export class ForecastVolumiModel {

  id: number;
  numAnnoMese: number;
  expectedVol: number;
  useExpectedVol: number;
  region: RegionModel;
  localCustomer: LocalCustomerModel;
  resourceUnit: ResourcesUnitModel;
  provider: ProviderModel;
  contractType: ContractTypeModel;


  constructor(id?: number, numAnnoMese?: number, expectedVol?: number, useExpectedVol?: number, region?: RegionModel, localCustomer?: LocalCustomerModel,
              resourceUnit?: ResourcesUnitModel, provider?: ProviderModel, contractType?: ContractTypeModel) {
    this.id = id;
    this.numAnnoMese = numAnnoMese;
    this.expectedVol = expectedVol;
    this.useExpectedVol = useExpectedVol;
    this.region = region;
    this.localCustomer = localCustomer;
    this.resourceUnit = resourceUnit;
    this.provider = provider;
    this.contractType = contractType;
  }
}
